import AccountInventoryService from '@/services/accountinventory.service.js'
import ChangeLogService from '@/services/changelog.service.js'
import { forEach } from 'lodash'

import { setTimeout } from 'timers'

export default {
  fetch: context => {

  },
  create: (context, accountData) => {

  },
  read: (context, id) => {

  },
  update: (context, updateAccount) => {
    context.commit('setFormDialogSaving', true, { root: true })
    AccountInventoryService.updateAccount(updateAccount, res => {
      context.commit('setFormDialogSaving', false, { root: true })
      context.commit('setFormDialogSuccess', true, { root: true })
      setTimeout(() => {
        context.commit('setFormDialogSuccess', false, { root: true })
      }, 2000)
    })
  },
  initCustomerById: (context, extId) => {
    context.commit('setLoader', { loading: true, text: 'Loading' }, { root: true })
    AccountInventoryService.getCustomersById(extId, res => {
      context.commit('setInitCustData', res)
      context.commit('setLoader', { loading: false }, { root: true })
    })
  },
  updateCustomer: (context, customerData) => {
    context.commit('setLoader', { loading: true, text: 'Loading' }, { root: true })
    AccountInventoryService.updateCustomer(customerData, res => {
      let routeId = vm.$route.params.id
      AccountInventoryService.getCustomersById(routeId, res => {
        context.commit('setInitCustData', res)
        context.commit('setLoader', { loading: false }, { root: true })
      })
    })
  },
  delete: (context, accountData, id) => {
    AccountInventoryService.flagAccount(accountData, (res, err) => {
      if (err) {
      } else {
        context.commit('deleteAccount', accountData.Acct_ID)
      }
      context.commit('resetDialog', null, { root: true })
    })
  },
  loadCustomers: (context) => {
    context.commit('setLoader', { loading: true, text: 'Loading' }, { root: true })
    AccountInventoryService.searchCustomers(null, (res, err) => {
      if (err) {
      } else {
        context.commit('loadCustomers', res)
      }
      context.commit('setLoader', { loading: false }, { root: true })
    })
  },
  getAccounts: (context, data) => {
    console.log('getting accounts')
    context.commit('setAccountData', [])
    context.commit('setLoadingAccountData', true)

    let columnFilters = {}
    let filterObj = {...context.state.accountDataFilters}
    
    for (const filter in filterObj) {
      if (Object.hasOwnProperty.call(filterObj, filter)) {
        const filterValue = filterObj[filter]
        if (filterValue) {
          columnFilters[filter] = filterValue
        }
      }
    }

    let params = {
      filters: columnFilters
    }

    if (data && data.hasOwnProperty('paginate') && data['paginate'] == 'next') {
      params['nextPaginationKey'] = context.state.nextPaginationKey
    }
    AccountInventoryService.getAllAccounts(params, (res, err) => {
      context.commit('setAccountData', res.data)
      context.commit('setNextData', res.next_data)
      context.commit('setLoadingAccountData', false)
    })
  },

  getNumberOfAccountsByCustomer (context) {
    context.commit('setLoadingCustomerAccounts', true)
    AccountInventoryService.getNumberOfAccountsByCustomer(null, (res, err) => {
      context.commit('setCustomerAccounts', res)
      context.commit('setLoadingCustomerAccounts', false)
    })

  },

  downloadAccounts (context) {
    context.commit('setDownloadingAccount', true)

    let columnFilters = {}
    let filterObj = {...context.state.accountDataFilters}
    
    for (const filter in filterObj) {
      if (Object.hasOwnProperty.call(filterObj, filter)) {
        const filterValue = filterObj[filter]
        if (filterValue) {
          columnFilters[filter] = filterValue
        }
      }
    }

    let params = {
      filters: columnFilters
    }

    AccountInventoryService.downloadAccounts(params, (res, err) => {

      console.log("response", res)
      // context.commit('setAccountData', res.data)
      // context.commit('setNextData', res.next_data)
      window.open(res, '_blank').focus();
      context.commit('setDownloadingAccount', false)
    })
  },

  updateFieldLastDateValidated (context, accountData) {
    let dialogDesc = accountData.selected.reduce((desc, accountData) => desc + `<li>${accountData.Last_Date_Validated}</li>`, '')
    let accountIds = accountData.selected.map((accountData) => accountData.Acct_ID)
    let strWorkloadIds = "('" + accountIds.join("','") + "')"
    let updateDate = accountData.updatedLastDateValidated
    let data = {
      Acct_ID: accountIds,
      Last_Date_Validated: updateDate
    }

    let lastDateValidated = accountData.selected.map((accountData) => {
      return { Last_Date_Validated: accountData.Last_Date_Validated }
    })
    context.commit('admin/setMassUpdateLastDateValidated', { id: accountIds, changeFrom: lastDateValidated, changeTo: { Last_Date_Validated: updateDate } }, { root: true })
    context.commit('setLastDateValidatedSaving', true)
    AccountInventoryService.submitMultipleAccounts(strWorkloadIds, updateDate, (res, err) => {
      if (err) {
      } else {
        context.commit('updateAccountLists', data)
        context.commit('setLastDateValidatedSaving', false)
        context.commit('showDialog', {
          type: 'alert',
          title: 'You successfully updated Last Date Validated ',
          show: true
        },
        { root: true })
        ChangeLogService.createMultiple(context.rootState.logRecord)
      }
    })
  },
  unArchive (context, account) {
    let accountIds = []
    if (Array.isArray(account)) {
      accountIds = account.map((item) => item.Acct_ID)
    } else {
      accountIds = [account.Acct_ID]
    }
    let strAcctIds = "('" + accountIds.join("','") + "')"

    AccountInventoryService.selectUnArchive(strAcctIds, (res, err) => {
      if (err) {
      } else {
        const recordToBeDeleted = context.state.accountData.findIndex(obj => accountIds.every(id => obj.Acct_ID === id))
        if (recordToBeDeleted !== -1) {
          context.state.accountData.splice(recordToBeDeleted, 1)
          context.commit('restoreAccounts', accountIds)
          context.commit('resetDialog', null, { root: true })
        }
      }
    })
  },
  validateAccountDetails: (context, accountData) => {
    if (typeof accountData === 'object') {

      context.commit('setLoader', { loading: true, text: 'Validating account...' }, { root: true })
      AccountInventoryService.validateAccountDetails(accountData, (res, err) => {
        
        accountData.Validation_Type = 'API'
        accountData.Last_Date_Validated = new Date().toISOString().substr(0, 10)
    
        if (typeof res === "string") {
          context.commit('showDialog', {
            type: 'alert', title: "Galaxy Account Inventory Validation", 
            description: res,
            show: true
            }, { root: true })
        } else if (res !== null) {
          context.commit('showDialog', {
              type: 'alert', title: 'AWS Organization API Account discrepancy',
              description: "Updated Account Details: <br/>" + JSON.stringify(res.mismatch, null, 1), show: true
            }, { root: true }
          )

          context.commit(
            'setChangeLogRecord', {
                id: accountData.Acct_ID, changeFrom: {...accountData}, changeTo: { ...res.mismatch }
            }, { root: true })
          let changeTo = res.mismatch
          let accountUpdate = '';
          Object.keys(changeTo).forEach(function(key) {
            if (accountData.hasOwnProperty(key)) {  
              accountUpdate += "From: " + accountData[key]  + "<br/>To: " + changeTo[key] + "<br/><br/>"
              accountData[key] = changeTo[key]
            }
          })
          
          let emailoBbject = { template: 'organization', oppreg_id: accountData.Acct_ID, note: accountUpdate }
          console.log('sending email...')
          AccountInventoryService.postEmailTemplate(emailoBbject) // send email if there are changes to the account details

          console.log('updating linked account details.')
          context.commit('updateAccountList', accountData)
          AccountInventoryService.updateAccount(accountData, (res, err) => {
            if (err) {
              console.log('error updating account: ' + err)
            } else {
              ChangeLogService.create(context.rootState.logRecord, "API")    
            }
          })
        
        }

        context.commit('setLoader', { loading: false }, { root: true })

      })

    } else {
      // AccountInventoryService.validateAccountDetails(accountData)
      // let message = "Master Payer Validation request was submitted, an email notification for the validation result will be sent shortly."
      let message = "Master Payer validation is still on going testing and no other master payer account is added."
    
      context.commit('showDialog', {
        type: 'alert', title: 'AWS Organization Master Payer Validation.',
        description: message, show: true
        }, { root: true }
      )
      
    }
  }
}
